import { Grid, styled, Typography } from "@mui/material";
// import { Realm } from "api/types";
import { RealmTagList } from "components/RealmTag";
import { TopicTagList } from "components/TopicTag";
// import { useState } from "react";

const PREFIX = "ActivitySearchBar";

const classes = {
	searchContainer: `${PREFIX}-searchContainer`,
	button: `${PREFIX}-button`,
	container: `${PREFIX}-container`,
	inputLabel: `${PREFIX}-inputLabel`,
};

const Root = styled("form")(({ theme }) => ({
	[`& .${classes.searchContainer}`]: {
		borderRadius: 4,
		backgroundColor: theme.palette.background.paper,
		padding: theme.spacing(2),
		marginBottom: theme.spacing(2),
		width: "inherit",
	},

	[`& .${classes.button}`]: {
		height: "100%",
	},

	[`& .${classes.container}`]: {
		paddingTop: theme.spacing(2),
	},

	[`& .${classes.inputLabel}`]: {
		"&": {
			backgroundColor: theme.palette.background.paper,
		},
	},
}));

export const RealmSelectBar = (props: {
	realm: any;
	setRealm: any;
	Topic: boolean;
}): JSX.Element => {
	// const [expanded, setExpanded] = useState(false);
	const { realm, setRealm, Topic } = props;
	const title = Topic ? "Topics" : "Realms";
	// const toggleExpansion = (): void => {
	// 	expanded ? setExpanded(false) : setExpanded(true);
	// };
	// window.console.log(realm);
	return (
		<Root>
			{/* {expanded && ( */}
			{/* <Grow in={expanded} timeout={1000}> */}
			<Grid container alignItems="flex-start">
				<Typography variant="h6" align="left">
					{title}
				</Typography>
				<Grid container>
					{Topic ? (
						<TopicTagList selected={realm} handler={setRealm} />
					) : (
						<RealmTagList selected={realm} handler={setRealm} />
					)}
				</Grid>
			</Grid>
			{/* </Grow> */}
			{/* )} */}
		</Root>
	);
};
